@if (shouldShowDropdown()) {
  <div class="w-80" data-testid="contributor-filter-dropdown">
    <label for="contributor-dropdown" class="block text-sm font-medium mb-2">
      {{ 'project.steps.contributor.filterByUser' | transloco }}
    </label>
    <p-select
      inputId="contributor-dropdown"
      [options]="contributorOptions()"
      [(ngModel)]="selectedContributorEmail"
      optionValue="value"
      [placeholder]="'project.steps.contributor.selectUser' | transloco"
      [disabled]="loading()"
      (ngModelChange)="onContributorChange()"
      class="w-full"
    >
      <ng-template #item let-option>
        <div [attr.data-testid]="'contributor-option-' + option.value">
          @if (option.label.startsWith('project.steps.')) {
            {{ option.label | transloco }}
          } @else {
            {{ option.label }}
          }
        </div>
      </ng-template>
      <ng-template #selectedItem let-option>
        <div [attr.data-testid]="'selected-contributor-' + option.value">
          @if (option && option.label.startsWith('project.steps.')) {
            {{ option.label | transloco }}
          } @else {
            {{ option?.label }}
          }
        </div>
      </ng-template>
    </p-select>
  </div>
}
